.mainDiv {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: var(--light-gray);
	top: auto;
	bottom: 0;
	min-height: 50px;
	width: 100%;
	overflow: auto;
}

.horizontalSpace {
	margin-left: 5px !important;
	margin-right: 5px !important;
}

@media (max-width: 540px) {
	.mainDiv {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		overflow: visible;
		width: 100%;
	}
	.trademarkRX {
		line-height: 50px !important;
	}
	.pipes {
		display: none;
	}
	.horizontalSpace {
		line-height: 50px !important;
	}
}
